import BobotNilai from '../../../views/Kurikulum/BobotNilai/BobotNilai.view';

export default BobotNilai;